import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { selectJump, selectSize, selectThemeSize, iconTheme } from "../../../data/data";
import { Router } from '@angular/router';
import { NzModalService, NzMessageService } from 'ng-zorro-antd';
@Component({
    selector: 'app-sucu05-button0020004',
    templateUrl: './sucu05-button0020004.component.html',
})


export class Sucu05Button0020004Component implements OnInit {

    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() isVisible = false;
    @Input() sets = {
        blockCode: "sucublock18",
        blockId: "",
        layoutId: "",
        blockType: 'formButton',
        blockChildType: '',
        versionCode: 6,
        styles: {
            nzText: "导出",
            nzExportExcelName: "导出工单",
            nzSheetNameArray: "sheet1",
            nzType: "default",
            nzSize: "default",
            nzBgColor: "",
            nzIcon: {
                nzIconType: '',
                nzIconTheme: '',
                nzIconColor: '',
            },
            nzOpen: true,
            nzConfirm: {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定吗？"
            },
        },
        datas: {
            nzFormCheck: false,
            nzMode: "frontExport",//backExport
            nzSecondSet: true,
            nzSecondSetData: "",
            nzDataSource: "",
            nzSearchLayout: "",
            nzJumpType: "self",
            nzJumpPageType: 0,
            nzJumpPage: "",
            nzJumpMode: "none",
            nzJumpModalTitle: "",
            nzJumpModalWidth: 520,
            nzSenceSelectValue: [],
            nzSenceValue: [],
            nzVirtualSenceSelectValue: [],
            nzVirtualSenceValue: [],
            nzSenceJson: [],
            exportSets: {
                headStyle: {
                    control: {
                        font: true,
                        alignment: true,
                        border: true,
                    },
                    font: {
                        name: '宋体',
                        size: 11,
                        bold: true
                    },
                    alignment: {
                        vertical: 'middle',
                        horizontal: 'center'
                    },
                    border: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    }
                },
                bodyStyle: {
                    control: {
                        font: true,
                        alignment: true,
                        border: true,
                    },
                    font: {
                        name: '宋体',
                        size: 11,
                        bold: false
                    },
                    alignment: {
                        vertical: 'middle',
                        horizontal: 'center'
                    },
                    border: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    }
                }

            }
        }
    };
    setData = [
        {
            tabName: '数据',
            datas: [
                {
                    type: 'datas',
                    data: [
                        { name: 'nzDataSource', },
                        {
                            name: 'select',
                            inputs: {
                                nzText: "搜索表单 : ", nzKeys: ['datas', 'nzSearchLayout'], nzData: this.setService.getBlock('formLayout', "*")
                            }
                        },
                        {
                            name: 'radio',
                            inputs: { nzText: "导出模式 : ", nzKeys: ['datas', 'nzMode'], nzData: [{ value: 'frontExport', label: '前端导出' }, { value: 'backExport', label: '后端导出' }] }
                        },
                        {
                            name: 'switch',
                            inputs: { nzText: "二次配置 : ", nzKeys: ['datas', 'nzSecondSet'], nzPopContent: "弹出弹框进行二次配置" }
                        },
                        {
                            name: 'button',
                            inputs: {
                                nzText: ["保存配置", '清空配置', '查看配置']
                            },
                            outputs: {
                                onClick1: () => {
                                    this.onClick1_save();
                                },
                                onClick2: () => {
                                    this.onClick2_delete();
                                },
                                onClick3: () => {
                                    this.onClick3_read();
                                }
                            }
                        },
                        {
                            name: 'switch',
                            inputs: { nzText: "表单校验 : ", nzKeys: ['datas', 'nzFormCheck'] }
                        },
                    ]

                }
            ]
        },
        {
            tabName: '样式',
            datas: [
                {
                    type: 'styles',
                    data: [
                        {
                            name: 'input',
                            inputs: {
                                nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                            }
                        },
                        {
                            name: 'input',
                            inputs: {
                                nzText: "导出文件名 : ", nzKeys: ['styles', 'nzExportExcelName']
                            }
                        },
                        {
                            name: 'input',
                            inputs: {
                                nzText: "工作表名称 : ", nzKeys: ['styles', 'nzSheetNameArray']
                            }
                        },


                        {

                            name: 'select',
                            inputs: {
                                nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                            }
                        },
                        {
                            name: 'radio',
                            inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                            outputs: {
                                ngModelChange: (event) => {


                                    if (event == 'twotone') {

                                        this.setService.setDatas[this.blockid][2]['datas'][0]['data'][4]['show'] = true;

                                    } else {
                                        this.setService.setDatas[this.blockid][2]['datas'][0]['data'][4]['show'] = false;

                                    }


                                    this.setService.onReLoadbBlock(this.layoutid);

                                }
                            }
                        },
                        {
                            name: 'input',
                            inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                            outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
                        },
                        {
                            name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                            inputs: {
                                nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                            }
                        },

                        {
                            name: 'color',
                            inputs: {
                                nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                            }
                        },
                        {
                            name: 'radio',
                            inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                        },
                        {
                            name: 'switch',
                            inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
                        },
                        { name: 'nzConfirm' }
                    ]
                },
            ]
        },
        {
            tabName: '导出样式',
            datas: [
                {
                    type: 'datas',
                    data: [
                        { name: 'exportSets' }
                    ]
                }
            ]
        },
    ]



    constructor(
        public setService: SetService,
        private modalService: NzModalService,
        private message: NzMessageService,

    ) { }
    ngOnInit() {


        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.autoUpdate();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }

                this.pzListening();
            }
            else {//静态
                if (typeof this.sets == "string")
                    this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
                this.autoUpdate();
            }
        }
        this.Listening();
    }
    autoUpdate() {


        // V2 按钮开放
        if (this.sets.versionCode < 2) {

            this.sets.styles['nzOpen'] = true;

            this.sets.versionCode = 2;
        }
        // V3 按钮确认
        if (this.sets.versionCode < 3) {

            this.sets.styles['nzConfirm'] = {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定要删除吗？"
            };

            this.sets.versionCode = 3;
        }
        if (this.sets.versionCode < 4) {

            this.sets.datas['nzMode'] = 'frontExport';
            this.sets.datas['nzSecondSet'] = true;

            this.sets.datas['exportSets'] = {
                headStyle: {
                    control: {
                        font: true,
                        alignment: true,
                        border: true,
                    },
                    font: {
                        name: '宋体',
                        size: 11,
                        bold: true
                    },
                    alignment: {
                        vertical: 'middle',
                        horizontal: 'center'
                    },
                    border: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    }
                },
                bodyStyle: {
                    control: {
                        font: true,
                        alignment: true,
                        border: true,
                    },
                    font: {
                        name: '宋体',
                        size: 11,
                        bold: false
                    },
                    alignment: {
                        vertical: 'middle',
                        horizontal: 'center'
                    },
                    border: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    }
                }

            }
            this.sets.versionCode = 4;
        }
        if (this.sets.versionCode < 5) {
            this.sets.datas['nzSecondSetData'] = '';
            this.sets.versionCode = 5;
        }
        if (this.sets.versionCode < 6) {

            this.sets.datas['nzFormCheck'] = false;
            this.sets.versionCode = 6;
        }


    }
    onClickEvents() {
        if (this.sets.datas.nzMode == 'backExport') {
            this.nzLoading = true;
            this.setService.sendEvent(this.sets.datas.nzDataSource, "export", {
                nzExportExcelName: this.sets.styles.nzExportExcelName,
                nzSheetNameArray: this.sets.styles.nzSheetNameArray,
                layoutid: this.sets.datas.nzSearchLayout,
                blockid: this.blockid
            })
        } else {
            this.frontExport()
        }

    }
    Listening() {

        this.setService.initEvent(this.blockid);
        this.setService.events[this.blockid].subscribe(
            data => {
                console.log("Listening:", data['type'], JSON.stringify(data));

                switch (data['type']) {

                    case 'nzLoadingOk':
                        this.nzLoading = false;
                        break;
                    case 'nzLoading':
                        this.nzLoading = true;
                        break;


                    default:
                        break;
                }
            }
        )

    }
    pzListening() {
        this.setService.initEvent(this.blockid, 'pz');
        this.setService.pzEvents[this.blockid].subscribe(
            data => {
                console.log('pzListening', data['type'])
                switch (data['type']) {
                    case 'onClick1_save':
                        this.sets.datas.nzSecondSetData = data.datas;
                        console.log('nzSecondSetData', this.sets.datas.nzSecondSetData)
                        break;
                    default:
                        break;
                }
            }
        )
    }
    frontExport(nzSecondSet = this.sets.datas.nzSecondSet, nzDefault = false) {
        this.setService.sendEvent(this.sets.datas.nzDataSource, "frontExport", {
            nzExportExcelName: this.sets.styles.nzExportExcelName,
            nzSheetNameArray: this.sets.styles.nzSheetNameArray,
            layoutid: this.sets.datas.nzSearchLayout,
            styles: this.sets.datas.exportSets,
            nzSecondSet: nzSecondSet,
            nzDefault: nzDefault,
            nzSecondSetData: this.sets.datas.nzSecondSetData,
            blockid: this.blockid
        })
    }
    onClick1_save() {
        this.setService.pzEvents[this.sets.datas.nzDataSource].emit({
            type: 'onClick1_save',
            datas: this.blockid
        })
    }
    onClick3_read() {
        this.frontExport(true, true);
    }
    onClick2_delete() {
        this.sets.datas.nzSecondSetData = "";
    }
    nzLoading = false;
    onClick(): void {
        if (!this.sets.styles.nzOpen) {
            this.message.create('info', `功能暂未开放`);
        } else {
            if (this.sets.styles.nzConfirm.nzShow) {
                this.modalService.confirm({
                    nzTitle: this.sets.styles.nzConfirm.nzTitle,
                    nzContent: this.sets.styles.nzConfirm.nzContent,
                    nzOnOk: () => this.onClickEvents()
                });
            }
            else {
                this.onClickEvents();
            }
        }

    }
}
